import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import TerminationAuditTable from './TerminationAuditTable';

const useStyles = makeStyles()(() => ({
  prealoderCard: {
    minHeight: '80vh'
  }
}));

const PAGE_SIZE = +process.env.REACT_APP_TABLE_SIZE;

export const TerminationAuditList = ({ config }) => {
  const { classes } = useStyles();
  const offenders = useSelector(config.selectors.selectList);
  const count = useSelector(config.selectors.selectCount);
  const loading = useSelector(
    isLoadingSelector([config.loadActionType.action])
  );
  const success = useSelector(successSelector([config.loadActionType.action]));

  // The backend returns the full, uncapped offender list in one request
  // (real offender counts are tiny against the whole portfolio it has to
  // scan) — pagination here is purely client-side so paging never
  // re-triggers a full portfolio schedule recomputation on the backend.
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [offenders]);

  const visibleOffenders = useMemo(
    () => offenders.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE),
    [offenders, page]
  );

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  if (success && !loading && count === 0) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords
          title={config.notFoundTitle}
          description={config.notFoundDescription}
        />
      </Card>
    );
  }

  return (
    <TerminationAuditTable
      offenders={visibleOffenders}
      count={count}
      limit={PAGE_SIZE}
      offset={page * PAGE_SIZE}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

TerminationAuditList.propTypes = {
  config: PropTypes.object.isRequired
};

export default TerminationAuditList;
